import { getIntendType, isWHW, isWWM, isWHWP2 } from './index';

export const postdataVal = (processingMTN, lines, isExpressCheckout) => {
  const value = {
    serviceHeader: {
      clientId: 'VZW-ECOM',
      statusMsg: 'PEGA generated message',
      correlationId: '69a66ef4d7e344dfb2db299209ea8333',
      sessionId: '',
      serviceName: 'SalesOrderPurchase',
      userId: '',
      statusCode: '0',
    },
    // expressCheckout: "true",
    serviceBody: {
      serviceRequest: {
        context: {
          skipCheckoutCall: true,
          customerInfo: {
            accountNumber: '',
            cartCreator: '',
            processingMTN,
          },
          cartInfo: {
            action: 'UPDATE',
            itemType: 'ISPUCONTACTINFO',
            userAction: 'updateContactInfo',
            updateShippingContactInfo: true,
            intendType: `${getIntendType()}`,
            contactInfo: {
              lines,
            },
          },
          contextInfo: {
            callReason: 'SalesOrderPurchase',
            intent: isWHW() || isWWM() || isWHWP2() ? 'RedemptionAccessory' : isExpressCheckout ? 'upgrade' : `${getIntendType()}`,
            processStep: isWHW() || isWWM() || isWHWP2() ? 'PromoHub' : isExpressCheckout ? 'ExpressCheckout' : 'ShippingOptions',
            processAction: 'updateShippingOptions',
          },
        },
      },
    },
  };
  if (isExpressCheckout) {
    value.expressCheckout = true;
  }
  return value;
};
